import { Spin } from 'antd'
import React, { useState, useRef } from 'react'
/**
 * modal内纵向滚动容器
 */
const ModalScrollContainer = (props) => {
    const ref = useRef()
    const [prevScrollTop, setPrevScrollTop] = useState(0);
    const handleScroll = (e) => {
        props.onScroll && props.onScroll(e)
        const bottomA = ref.current.scrollHeight - ref.current.scrollTop - ref.current.clientHeight
        if (bottomA < 50 && (ref.current.scrollTop > prevScrollTop) ) {
            props.onScrollBottom && props.onScrollBottom(e)
        }
        setPrevScrollTop(ref.current.scrollTop )
    }
  
    const style = {
        padding: 24, 
        overflowY: 'auto', 
        maxHeight: 'calc(100vh - 235px)',
        ...props.style
    }
    return (
        <Spin spinning={!!props.loading}>
            <div style={style} ref={ref} onScroll={handleScroll}>{props.children}</div>
        </Spin>
    )
}

export default ModalScrollContainer


// WEBPACK FOOTER //
// ./src/components/ModalScrollContainer/index.jsx